import React, { useState } from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Upload, X, Image as ImageIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';

const ImageUpload = ({ name, label, onImageChange, currentImage = null }) => {
  const [preview, setPreview] = useState(currentImage);
  const [fileName, setFileName] = useState('');

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validar tamanho (máximo 2MB)
    const maxSize = 2 * 1024 * 1024; // 2MB em bytes
    if (file.size > maxSize) {
      alert('Arquivo muito grande! Tamanho máximo: 2MB');
      e.target.value = '';
      return;
    }

    // Validar tipo
    const validTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/jpg'];
    if (!validTypes.includes(file.type)) {
      alert('Tipo de arquivo inválido! Use: JPEG, PNG ou WebP');
      e.target.value = '';
      return;
    }

    setFileName(file.name);

    // Criar preview
    const reader = new FileReader();
    reader.onloadend = () => {
      setPreview(reader.result);
      // Passar a URL base64 para o componente pai
      if (onImageChange) {
        onImageChange(reader.result);
      }
    };
    reader.readAsDataURL(file);
  };

  const clearImage = () => {
    setPreview(null);
    setFileName('');
    if (onImageChange) {
      onImageChange('');
    }
  };

  return (
    <div>
      <Label>{label}</Label>
      
      {/* Info sobre requisitos */}
      <div className="text-xs text-gray-500 mb-2 space-y-1">
        <p>📏 Tamanho máximo: 2MB</p>
        <p>🖼️ Formatos aceitos: JPEG, PNG, WebP</p>
        <p>📐 Recomendado: Mínimo 400x400px</p>
      </div>

      {/* Preview da imagem */}
      {preview && (
        <div className="relative mb-3 w-full h-48 border-2 border-gray-300 rounded-lg overflow-hidden bg-gray-100">
          <img 
            src={preview} 
            alt="Preview" 
            className="w-full h-full object-contain"
          />
          <button
            type="button"
            onClick={clearImage}
            className="absolute top-2 right-2 bg-red-600 text-white p-1 rounded-full hover:bg-red-700"
          >
            <X size={16} />
          </button>
        </div>
      )}

      {/* Input de arquivo */}
      <div className="flex items-center gap-2">
        <label className="flex-1 cursor-pointer">
          <div className="flex items-center justify-center gap-2 p-3 border-2 border-dashed border-gray-300 rounded-lg hover:border-red-600 hover:bg-red-50 transition">
            <Upload className="text-gray-500" size={20} />
            <span className="text-sm text-gray-600">
              {fileName || 'Clique para selecionar imagem'}
            </span>
          </div>
          <Input
            type="file"
            name={name}
            accept="image/jpeg,image/png,image/webp,image/jpg"
            onChange={handleFileChange}
            className="hidden"
          />
        </label>
      </div>

      {/* Ou URL alternativa */}
      <div className="mt-3">
        <Label className="text-xs text-gray-600">Ou cole uma URL de imagem:</Label>
        <Input
          name={`${name}_url`}
          placeholder="https://exemplo.com/imagem.jpg"
          onChange={(e) => {
            if (e.target.value) {
              setPreview(e.target.value);
              if (onImageChange) {
                onImageChange(e.target.value);
              }
            }
          }}
        />
      </div>
    </div>
  );
};

export default ImageUpload;
